module.exports = __webpack_public_path__ + "img/中繼站2_說明頁.f336b3b3.png";